import gql from 'graphql-tag';
import { networkGQLFields } from './network.fields.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function customCodeGQLFields(fields) {
    return `
    anonymize
    position
    code
  `;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function topNavigationGQLFields(fields) {
    return `
    enabled
    items {
      link
      openInNewWindow
      text
      type
    }
  `;
}
export function getNetworkGQLQuery(fields) {
    return gql `
    query getNetwork {
      network {
        ${networkGQLFields(fields)}
      }
    }
  `;
}
export function updateNetworkGQLQuery(fields) {
    return gql `
    mutation updateNetwork($input: UpdateNetworkInput!) {
      updateNetwork(input: $input) {
        ${networkGQLFields(fields)}
      }
    }
  `;
}
//# sourceMappingURL=network.gql.js.map